<template>
    <div class="text-left">
        <div class="flex flex-row w-full" v-if="viewState === viewStates.ANSWERING">
            <div class="flex flex-col flex-grow p-4 | overflow-hidden w-full ">
                <ProgressBar class="p-5"/>

                <SideBar class="bg-cover sidebar pt-4 | block lg:hidden | lg:p-5 lg:w-96" />

                <QuestionsPage  class="p-5" />

                <Navigation class="p-5"/>
            </div>
            <SideBar class="w-96 p-5 bg-cover sidebar | hidden lg:block"/>
        </div>

        <div  class="flex flex-row w-full relative h-56" v-if="viewState === viewStates.SENDING">
            <AjaxLoader :loadingText="$t('Bezig met versturen...')"/>
        </div>

        <div  class="flex flex-row w-full" v-if="viewState === viewStates.FINISHED">
            <FinishScreen/>
        </div>

        <div  class="flex flex-row w-full" v-if="viewState === viewStates.FAILED">
            FAILED
        </div>

    </div>
</template>
<style lang="scss">
.sidebar{
    @media(min-width: 1024px){
        box-shadow: 0 9px 56px rgb(0 0 0 / 15%);
    }
    @screen 2xl{
        flex: 0 0 430px;
    }
}
</style>
<script>
import { useStore } from 'vuex'
import ProgressBar from "./FunnelQuiz/ProgressBar";
import QuestionsPage from "./FunnelQuiz/QuestionsPage";
import SideBar from "./FunnelQuiz/SideBar";
import Navigation from "./FunnelQuiz/Navigation";
import {computed} from "vue";
import {ViewStates} from "../Store/ViewStates";
import AjaxLoader from "./FunnelQuiz/AjaxLoader";
import FinishScreen from "./FunnelQuiz/FinishScreen";
const viewStates = ViewStates;

export default {
    components:{
        FinishScreen,
        AjaxLoader,
        Navigation,
        SideBar,
        QuestionsPage,
        ProgressBar
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        store.commit('setQuizData', props.quizData);

        return {
            viewState: computed(() => store.state.viewState),
            currentPage: computed(() => store.state.currentPageNumber),
            viewStates: viewStates
        }
    },
    methods:{

    },
    name: "FunnelQuiz",
    props: {
        quizData: {
            type: Object,
            required: true,
        },
    }
}
</script>
